import type { BetaFeatureDefinition } from "./betaFeatures.types";

/**
 * Beta-eligible client flags: the single place to add one. Not eligible: platform rollout
 * keys, which tenants and users never control.
 */
export const BETA_FEATURE_REGISTRY: readonly BetaFeatureDefinition[] = [
  { key: "DESIGN_SYSTEM_SHOWCASE", flag: "DESIGN_SYSTEM_SHOWCASE" },
  { key: "SENSITIVITY_REVIEW", flag: "SENSITIVITY_REVIEW" },
];

export const BETA_FEATURE_FLAGS: readonly string[] = BETA_FEATURE_REGISTRY.map(
  (feature) => feature.flag,
);
